<template>
  <div class="wrapper">
    <page-header title="Aplikacje" :avatar="userInfo.avatar_preview" />
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
      readOnly
    />
  </div>
</template>
<script>
import ApplicationList from '@/views/ExtendableBases/ApplicationList/'

export default {
  extends: ApplicationList
}
</script>
